import { render, staticRenderFns } from "./TnLocalTime.vue?vue&type=template&id=0229b33b"
import script from "./TnLocalTime.vue?vue&type=script&lang=js"
export * from "./TnLocalTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports